import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useFormContext } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import {
  FieldsetCard,
  FieldsetCardProps,
  getDisabledClasses,
} from "~/common/components/ui/FieldsetCard";
import Input from "~/common/components/ui/Input";
import Select from "~/common/components/ui/select/Select";
import { NOT_AVAILABLE, usaStatesOptions } from "~/common/constants";
import { UpdatePatientDetailsForm } from "~/providers/types/patients";

export const AddressFieldset = ({
  disabled,
  ...props
}: Omit<FieldsetCardProps, "title" | "className">) => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext<UpdatePatientDetailsForm>();

  return (
    <FieldsetCard
      title="Address"
      className="border-none p-0 shadow-none"
      contentClassName={twMerge(
        "grid-cols-2 sm:grid-cols-4",
        !disabled && "sm:grid-cols-6",
      )}
      disabled={disabled}
      {...props}
    >
      <Input
        label="Street address"
        {...getDisabledClasses(disabled)}
        {...register("streetAddress")}
        error={errors.streetAddress?.message}
        disabled={disabled}
        containerClassName={twMerge(!disabled && "sm:col-span-3")}
      />
      <Input
        label="Apartment"
        {...getDisabledClasses(disabled)}
        {...register("apartment")}
        error={errors.apartment?.message}
        disabled={disabled}
        placeholder={disabled ? NOT_AVAILABLE : undefined}
        containerClassName={twMerge(!disabled && "sm:col-span-3")}
      />
      <Input
        label="City"
        {...getDisabledClasses(disabled)}
        {...register("city")}
        error={errors.city?.message}
        disabled={disabled}
        containerClassName={twMerge(!disabled && "sm:col-span-2")}
      />
      <Select
        id="state"
        label="State"
        placeholder={"Enter state"}
        options={usaStatesOptions}
        control={control}
        containerClassName={twMerge("gap-2", !disabled && "sm:col-span-2")}
        isDisabled={disabled}
        buttonClassName="disabled:bg-transparent disabled:border-none disabled:p-0 disabled:h-auto"
        icon={disabled ? <ChevronDownIcon /> : undefined}
        error={errors.state?.message}
      />
      <Input
        label="ZIP code"
        {...getDisabledClasses(disabled)}
        {...register("zipCode")}
        error={errors.zipCode?.message}
        disabled={disabled}
        containerClassName={twMerge(!disabled && "sm:col-span-2")}
      />
    </FieldsetCard>
  );
};
